/**
 * Map a notification to its in-app deep-link target.
 * Returns a path string (suitable for react-router navigate).
 * Falls back to "/feed" when there is no specific target.
 */
export function notificationHref(n) {
  if (!n) return "/feed";
  const t = n.type;
  const tid = n.target_id;
  const ttype = n.target_type;
  const gid = n.group_id;

  // DM-related → /messages, scoped to the partner when known.
  if (t === "dm" && tid) return `/messages?to=${tid}`;
  if (t === "dm_muted" || t === "dm_unmuted") return "/messages";

  // Friend lifecycle → friends page.
  if (t === "friend_request" || t === "friend_accepted") return "/friends";

  // Application lifecycle → feed (the welcome screen).
  if (t === "application_approved" || t === "application_rejected") return "/feed";

  // Role events → admin dashboard / target group page.
  if (t === "promoted_admin") return "/admin";
  if (t === "group_moderator_added" && (gid || tid)) return `/groups/${gid || tid}`;

  // Story-targeted events (like / comment / admin_story / story_new).
  // Personal feed → open the modal directly via ?story=<id>.
  // Group-scoped → just land on the group page (no modal in GroupDetail).
  if (ttype === "story" && tid) {
    return gid ? `/groups/${gid}` : `/feed?story=${tid}`;
  }

  // Events: new event / RSVP'd / event update — open the event detail page.
  if (ttype === "event" && tid) {
    return `/events/${tid}`;
  }

  // Broadcast-targeted (admin_broadcast). Show the broadcasts on the feed
  // (or the group's feed). No modal — broadcasts are inline cards.
  if (ttype === "broadcast") {
    return gid ? `/groups/${gid}` : "/feed";
  }

  // Group target without explicit type.
  if (ttype === "group" && tid) return `/groups/${tid}`;

  return "/feed";
}
